import { BadgeCommonProps } from "@certn/cascadia/components/badge/types";

import { _Badge } from "./_Badge";

export function DangerBadge(props: BadgeCommonProps) {
  const {
    type = "bold",
    testID = "danger-badge",
    size = "large",
    ...rest
  } = props;

  if (type === "bold")
    return (
      <_Badge
        fill="background-accent-red-strong"
        color="text-accent-red-weak"
        testID={testID}
        size={size}
        {...rest}
      />
    );

  return (
    <_Badge
      fill="background-accent-red-weak"
      color="text-accent-red-strong"
      testID={testID}
      size={size}
      {...rest}
    />
  );
}
